import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import EventBanner from './EventBanner'; // ✅ Add this line
import CommitmentSection from "../CommitmentSection";
import SocialInfo from './SocialInfo';

const MarketingEventsDetails = () => {
  return (
    <>
      <NavbarComponent />
      <EventBanner />
      <CommitmentSection />
      <SocialInfo/>
      <Footer />
    </>
  );
};

export default MarketingEventsDetails;
